module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('side-bar', {
    attrs: {
      "type": "navbar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('p', [_vm._v("Logout")])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc704898!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 457
// module chunks = 1